import "../common/elements/Header.scss";
import translate from "@/i18n/translate";
import Header from "@/features/common/elements/Header";
import OrgProfileContent from "@/features/common/elements/OrgProfileContent";
import { useContext, useReducer } from "react";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";
import PreviewModal from "../lightcast/PreviewModal";
import UnauthorizedComponent from "@/features/insights/UnauthorizedComponent";
import { usePageTitle } from '@/hooks/usePageTitle';
import { useIntl } from 'react-intl';
import { WmButton, WmModal, WmModalHeader, WmModalFooter } from "@watermarkinsights/ripple-react";
export interface OrgProfileComponentProps {
  setSelectedTabView: (tabId: string) => void;
  auth: boolean;
}

type ModalAction = { type: "open" } | { type: "close" };

function modalReducer(_state: boolean, action: ModalAction): boolean {
  return action.type === "open";
}

export default function OrgProfileComponent({
  setSelectedTabView,
  auth
}: OrgProfileComponentProps): JSX.Element {
  const { institution, isAiAssistantAvailable } = useContext<AppContextInterface>(AppContext);
  const intl = useIntl();
  const [insightsInfoModalOpen, dispatch] = useReducer(modalReducer, false);

  const pageTitle = institution?.name
    ? `${institution.name} - ${intl.formatMessage({ id: 'app.pageTitle.institutionProfile' })}`
    : intl.formatMessage({ id: 'app.pageTitle.institutionProfile' });

  usePageTitle(pageTitle);

  let displayName = institution && institution.name;
  return (
    <>
      {auth ? (
        <>
          <Header displayName={displayName} />

          <div className="insights-hub-body flex-row">
            <div id="main-org-profile-container" className="main-org-profile">
              <div>
                <div className="page-banner -insights-header insights-header-home">
                  <h2 className="titles">{intl.formatMessage({ id: "app.header.title" })}</h2>
                  <div className="description">
                    {translate("app.header.description")}
                  </div>
                  {isAiAssistantAvailable && (
                    <WmButton
                      className="insights-info-button"
                      buttonType="textonly"
                      icon="/images/icons-sprite.svg#info-outline"
                      iconSize="1rem"
                      onClick={() => dispatch({ type: "open" })}
                    >
                      {intl.formatMessage({ id: "app.header.insightsInfoModal.heading" })}
                    </WmButton>
                  )}
                </div>
                {isAiAssistantAvailable && (
                  <WmModal
                    open={insightsInfoModalOpen}
                    id="insights-info-modal"
                    uid="insights-info-modal"
                    modalType="dialog"
                    elementToFocus="primary"
                    aria-label="Where do these insights come from?"
                    onWmModalCloseTriggered={() => dispatch({ type: "close" })}
                    onWmModalPrimaryTriggered={() => dispatch({ type: "close" })}
                  >
                    <WmModalHeader heading="Where do these insights come from?"></WmModalHeader>
                    <div className="modal-content body">
                      <p>
                        {intl.formatMessage({ id: "app.header.insightsInfoModal.body1" })}
                      </p>
                      <p>
                        {intl.formatMessage({ id: "app.header.insightsInfoModal.body2" })}
                      </p>
                    </div>
                    <WmModalFooter primaryText="Close" deleteStyle={false}></WmModalFooter>
                  </WmModal>
                )}
                <div className="body -height" id="tab-components">
                  <OrgProfileContent
                    setSelectedTabView={setSelectedTabView}
                    productView="navigator"
                  />
                </div>
              </div>
            </div>
          </div>
          <PreviewModal></PreviewModal>
        </>
      ) : (
        <UnauthorizedComponent />
      )}
    </>
  );
}